/**
 * @author vishwadeep.kapoor
 * @Date: 2020-11-20 16:57:13
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-20 18:46:13
 */

import React, { Fragment } from 'react';
import { shape } from 'prop-types';
import Trusted from '../NewLanding/Trusted';
import Journey from '../NewLanding/Journey';
import { AppWrappperHOC } from '../Root/HOC';
import { HelmetWrapper } from '../../components';
import PartnerBannersApp from './partnerBannersApp';

const SwitchSolutionRoute = (type) => {
  switch (type) {
    default:
      return <PartnerBannersApp />;
  }
};


const SolutionWrapper = (props) => {
  const { match: { params: { type } = {} }, location } = props;
  return (
    <Fragment>
      <HelmetWrapper location={location} />
      {SwitchSolutionRoute(type)}
      <Trusted />
      <Journey />
    </Fragment>);
};

SolutionWrapper.propTypes = {
  match: shape({}).isRequired,
  location: shape({}).isRequired,
};
export default AppWrappperHOC(SolutionWrapper);



// WEBPACK FOOTER //
// client/containers/PartnerBanners/index.jsx